module.exports = __webpack_public_path__ + "media/images/marble-c7d4c9cda1bffb396d0f9cdcc9bd8856.jpg";